export default __webpack_public_path__ + "static/media/C-21.edd0dec7.png";